import update from 'immutability-helper'
import {
  STATISTICS_GET_CHART,
  STATISTICS_GET_TOPLIST,
  STATISTICS_GET_TREND,
  STATISTICS_GET_STATUS,
} from '../actions/action-types'
import { crunchToPieData } from '../../util/compatibilityBridge'

const initialState = {
  status: {},
  toplist: {
    list: [],
    trend: [],
  },
  gender: {
    bar: [],
    pie: [],
  },
  channels: {
    bar: [],
    pie: [],
  },
  returning: {
    bar: [],
    pie: [],
  },
  paymentmethods: {
    bar: [],
    pie: [],
  },
}

const _concat = (a, b) => a.concat(b)

const getKeys = data =>
  Object.keys(
    (data || [])
      .map(({ values = {} }) => Object.keys(values))
      .reduce(_concat, [])
      // eslint-disable-next-line no-template-curly-in-string
      .filter(key => key !== '${unknown}')
      .reduce(
        (prev, next) => ({
          ...prev,
          [next]: next,
        }),
        {},
      ),
  )

// eslint-disable-next-line default-param-last
const statistics = (state = initialState, action) => {
  switch (action.type) {
    case STATISTICS_GET_CHART:
      return {
        ...state,
        [action.target]: {
          pie: crunchToPieData(action.data),
          bar: action.data,
          keys: getKeys(action.raw),
        },
      }
    case STATISTICS_GET_TOPLIST:
      return update(state, {
        [action.target]: { $merge: action.response },
      })
    case STATISTICS_GET_TREND:
      return update(state, {
        [action.target]: { $merge: action.response },
      })
    case STATISTICS_GET_STATUS:
      return update(state, {
        status: { $set: action.response.data },
      })
    default:
      return state
  }
}

export default statistics
